import { render, staticRenderFns } from "./unidadMedidaEdit.vue?vue&type=template&id=1b3d4895&"
import script from "./unidadMedidaEdit.vue?vue&type=script&lang=js&"
export * from "./unidadMedidaEdit.vue?vue&type=script&lang=js&"
import style0 from "./unidadMedidaEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports